import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { ROGUING_REMARKS } from '../../../../../res/Constants';
import { extractRoguingRemarks } from '../../../../../service/CommonFunctions';
import { getHarvestLines } from '../../../../../utils/Utils';
import GreenRedTimeLine from './../components/GreenRedTimeLine';

class Roguing extends PureComponent {
    static propTypes = {
        cacType: PropTypes.number.isRequired,
        techFormData: PropTypes.object.isRequired
    };

    render() {
        const { cacType, techFormData } = this.props;
        const lines = extractRoguingRemarks(techFormData);
        const lineLabels = getHarvestLines(cacType, techFormData.contractHarvest);

        return (
            <GreenRedTimeLine
                cacType={cacType}
                title={ROGUING_REMARKS}
                lines={lines}
                lineCount={this.props.techFormData.line}
                lineLabels={lineLabels}
            />
        );
    }
}

export default Roguing;
